<p class="help is-danger" [class.hide]="_hide">{{_text}}</p>